import React, { useEffect, useRef, useState } from "react";

import styles from "./index.module.css";
import classNames from "classnames";
import ArrowBackIosOutlinedIcon from "@material-ui/icons/ArrowBackIosOutlined";
import ArrowForwardIosOutlinedIcon from "@material-ui/icons/ArrowForwardIosOutlined";

const ScrollBar = ({
  list,
  value,
  onChange,
  useCustomStyles = false,
  customStyles = null,
}) => {
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const [tabItems, setTabItems] = useState([]);
  const [activeTab, setActiveTab] = useState(value);
  const tabListRef = useRef(null);
  const tabRefs = useRef({});
  const handleTabClick = (id) => {
    setActiveTab(id);
    /*  scrollToId(id); */
    const ref = tabRefs?.current?.[id];
    if (ref?.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        inline: "center", // or 'nearest', depending on UX
        block: "nearest",
      });
    }
    onChange(id);
  };

  const updateArrowVisibility = () => {
    if (!tabListRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = tabListRef.current;

    setShowLeftArrow(scrollLeft > 0);
    setShowRightArrow(scrollLeft + clientWidth < scrollWidth - 1); // subtract 1 to prevent rounding errors
  };

  useEffect(() => {
    setActiveTab(value);

    // eslint-disable-next-line
  }, [value]);
  useEffect(() => {
    if (list?.length) {
      setTabItems(list);
    }
  }, [list]);

  useEffect(() => {
    const checkForOverflow = () => {
      if (tabListRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = tabListRef.current;
        setShowLeftArrow(scrollLeft > 0);
        setShowRightArrow(scrollLeft + clientWidth < scrollWidth);
      }
    };

    checkForOverflow();
    window.addEventListener("resize", checkForOverflow);

    return () => {
      window.removeEventListener("resize", checkForOverflow);
    };
  }, [tabItems]);

  useEffect(() => {
    const tabList = tabListRef.current;
    if (!tabList) return;

    updateArrowVisibility(); // initial check

    tabList.addEventListener("scroll", updateArrowVisibility);
    window.addEventListener("resize", updateArrowVisibility); // optional: recalc on resize

    return () => {
      tabList.removeEventListener("scroll", updateArrowVisibility);
      window.removeEventListener("resize", updateArrowVisibility);
    };
  }, []);

  useEffect(() => {
    if (!tabItems || tabItems.length === 0) return;

    // Create a ref for each tab if it doesn't already exist
    tabItems.forEach((tab) => {
      if (!tabRefs.current[tab._id]) {
        tabRefs.current[tab._id] = React.createRef();
      }
    });
  }, [tabItems]);

  if (!tabItems?.length) {
    return null;
  }
  return (
    <div
      className={
        useCustomStyles ? customStyles?.wrapper : styles.tabsScrollWrapper
      }
    >
      {showLeftArrow && (
        <button
          className={styles.arrowBtn}
          onClick={() => {
            if (tabListRef.current) {
              tabListRef.current.scrollLeft -= 150;
            }
          }}
        >
          <ArrowBackIosOutlinedIcon
            style={{
              color: "black",
              fontSize: "15px",
            }}
          />
        </button>
      )}

      <div
        className={useCustomStyles ? customStyles?.tabList : styles.tabList}
        ref={tabListRef}
      >
        {tabItems?.map((item) => (
          <button
            key={item?._id}
            onClick={() => handleTabClick(item?._id)}
            className={classNames(
              useCustomStyles ? customStyles?.tabItem : styles.tabItem,
              activeTab === item._id
                ? useCustomStyles
                  ? customStyles.activeTab
                  : styles.active
                : ""
            )}
            style={{
              color: !useCustomStyles && "black",
              borderBottom:
                !useCustomStyles &&
                activeTab === item._id &&
                `0.1px solid black`,
            }}
            //  ref={tabRefs?.current[item._id]}
          >
            {item?.Name !== "" ? item?.Name : "Sin definir"}
          </button>
        ))}
      </div>
      {showRightArrow && (
        <button
          className={styles.arrowBtn}
          onClick={() => {
            if (tabListRef.current) {
              tabListRef.current.scrollLeft += 150;
            }
          }}
        >
          <ArrowForwardIosOutlinedIcon
            style={{
              color: "black",
              fontSize: "15px",
            }}
          />
        </button>
      )}
    </div>
  );
};

export default ScrollBar;
